import React from "react";
import { Modal } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

export interface IReleaseVehicleActionProps {
  visibleModal: boolean;
  vehiclePlateSelected: string;
  handleClickConfirm: (...args) => void;
  hideModal: (...args) => void;
  disabledButton: boolean;
}

const ReleaseVehicleAction = ({ visibleModal, vehiclePlateSelected, handleClickConfirm, hideModal, disabledButton }: IReleaseVehicleActionProps): JSX.Element => {
  return (
    <S.VehicleActionContainer>
      <Modal
        title={useTranslation({ id: "release_vehicle_title" })}
        centered
        maskClosable={false}
        confirmLoading={disabledButton}
        open={visibleModal}
        onOk={() => handleClickConfirm()}
        onCancel={() => hideModal()}
        okText={useTranslation({ id: "confirm" })}
        cancelText={useTranslation({ id: "cancel" })}
        bodyStyle={{ height: "auto" }}
      >
        <S.DescriptionVehicleAction>
          {useTranslation({ id: "release_vehicle_description" })} <S.VehiclePlate>{vehiclePlateSelected}</S.VehiclePlate> ?
        </S.DescriptionVehicleAction>
      </Modal>
    </S.VehicleActionContainer>
  );
};

export default ReleaseVehicleAction;
